export default __webpack_public_path__ + "static/media/comingSoonElite.e98b3c14.svg";